import { storeUserError, updateLogoutDate, userRenewed, userSignedOut } from "../actions/authActions";
import { store } from "../../src/store";
import { createUserManager, createUserManagerWithRedirect } from "./helpers";
import { resetUserCache } from "../../src/actionCreators/userProfileActionCreators";
import { LocalStorageConstants } from "../../src/Core/Common/Constants";

export let userManager = createUserManager();

export async function loadUserFromStorage(store: any) {
    try {
        const user = await userManager.getUser();
        if (!user) {
            return store.dispatch(storeUserError());
        }
        store.dispatch(userRenewed(user));
    } catch (e) {
        console.error(`User not found: ${e}`);
        store.dispatch(storeUserError());
    }
}

export function signinRedirect() {
    return userManager.signinRedirect();
}

export function signinRedirectCallback() {
    return userManager.signinRedirectCallback();
}

export const signinRedirectWithCallbackArgs = (args: string) => {
    if (args) {
        const redirectUri = userManager.settings.redirect_uri + "?callback_args=" + encodeURIComponent(args);
        userManager = createUserManagerWithRedirect(redirectUri);
    }
    userManager.signinRedirect();
};

export async function signoutRedirect(dispatch?: any) {
    const user = await userManager.getUser();
    userManager.clearStaleState();
    userManager.removeUser();
    // await updateLogoutDate();
    if (dispatch) {
        dispatch(resetUserCache());
    }
    store.dispatch(userSignedOut());
    localStorage.removeItem(LocalStorageConstants.USER_ID);
    localStorage.removeItem(LocalStorageConstants.IS_ADMIN);
    localStorage.setItem(LocalStorageConstants.USER_LOGGED_OUT, "true");
    return userManager.signoutRedirect({
        id_token_hint: user?.id_token,
        post_logout_redirect_uri: window.location.origin + "/signout-callback-oidc",
    });
}

export function signoutRedirectCallback() {
    userManager.clearStaleState();
    userManager.removeUser();
    return userManager.signoutRedirectCallback();
}

export function getAccessToken() {
    if (localStorage.getItem(LocalStorageConstants.USER_LOGGED_OUT) === "true") {
        return null;
    }

    const user = store?.getState()?.userAuth?.user;
    return user?.access_token;
}

export default userManager;
